import { SearchIcon, XIcon } from 'lucide-react'
import { memo, type ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

import type { DataTableSearchProps } from './data-table.interface'

const DataTableSearchBase: React.FC<DataTableSearchProps> = ({
  value,
  onChange,
  placeholder = 'Search...',
  className,
}): ReactNode => {
  const handleClear = (): void => {
    onChange('')
  }

  return (
    <div className={cn('data-table-search relative', className)}>
      <SearchIcon className="absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="data-table-search-input h-9 w-[200px] pl-8 pr-8 lg:w-[280px]"
      />
      {value && (
        <Button
          variant="ghost"
          size="icon"
          className="data-table-search-clear absolute right-1 top-1/2 size-6 -translate-y-1/2"
          onClick={handleClear}
        >
          <XIcon className="size-3" />
          <span className="sr-only">Clear search</span>
        </Button>
      )}
    </div>
  )
}

export const DataTableSearch = memo(DataTableSearchBase)

DataTableSearch.displayName = 'DataTableSearch'
